import React from "react";

function Logo() {
  return (
    <>
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0892029 24L-9.31551e-06 0.0892132L11.9554 0.0446071C18.5582 0.0199719 23.9307 5.35261 23.9554 11.9554C23.98 18.5582 18.6474 23.9308 12.0446 23.9554L0.0892029 24Z"
          fill="url(#paint0_linear)"
        />
        <g clipPath="url(#clip0)">
          <path
            d="M15.8124 5.27722H11.391C10.8387 5.27722 10.391 5.72494 10.391 6.27722V18.2875C10.391 18.8398 10.8387 19.2875 11.391 19.2875H15.8124C16.3647 19.2875 16.8124 18.8398 16.8124 18.2875V6.27722C16.8124 5.72494 16.3647 5.27722 15.8124 5.27722Z"
            fill="white"
          />
          <path
            d="M8.22347 5.27722H3.80206C3.24978 5.27722 2.80206 5.72494 2.80206 6.27722V10.6986C2.80206 11.2509 3.24978 11.6986 3.80206 11.6986H8.22347C8.77576 11.6986 9.22347 11.2509 9.22347 10.6986V6.27722C9.22347 5.72494 8.77576 5.27722 8.22347 5.27722Z"
            fill="white"
          />
          <path
            d="M8.22347 12.8661H3.80206C3.24978 12.8661 2.80206 13.3139 2.80206 13.8662V18.2876C2.80206 18.8398 3.24978 19.2876 3.80206 19.2876H8.22347C8.77576 19.2876 9.22347 18.8398 9.22347 18.2876V13.8661C9.22347 13.3139 8.77575 12.8661 8.22347 12.8661Z"
            fill="white"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1={-3}
            y1="-3.5"
            x2={30}
            y2="32.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#511A79" />
            <stop offset="0.882075" stopColor="#ED670E" />
          </linearGradient>
          <clipPath id="clip0">
            <rect
              width="14.0103"
              height="14.0103"
              fill="white"
              transform="translate(2.80206 5.27722)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export { Logo };
